import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=5754e9f8"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=5754e9f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports